import {
  aikaPvmStringLong,
  checkResponse,
  convertMinutesToHoursAndMinutes,
  kestoString,
  pvmStringLong,
} from "src/components/js/statics1";
import { person_fetch_by_id } from "../person/PersonFunctions";

export default class mailClass {
  constructor(keikkaData) {
    // templateId: d-d1e5ed7affbe4cc5843fe2be6326c6f6 : tilaustiedot, tilausvahvistus jne.
    this.emailToEmail = keikkaData.keikkaContactPerson.personEmail;
    this.emailFromEmail = "tilaus@betoni.online";
    this.emailFromName = "betoni.online";
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";
    this.buttonUrl = "https://betoni.online/tilaus/" + keikkaData.keikkaId;
    this.ownerAsiakasId = keikkaData.ownerAsiakasId || 8;

    this.replyToEmail = "info@kalleurho.fi";
    this.replyToName = "Kalle Urho Oy";

    this.nyt = aikaPvmStringLong(new Date(), true);
    this.pvm = pvmStringLong(keikkaData.pumppu.pumppuAika);
    if (keikkaData.pumppu.ehdotaAikaa) {
      this.klo =
        "Ehdota valuajankohta asiakkaalle. " +
        convertMinutesToHoursAndMinutes(keikkaData.pumppu.pumppuKesto);
    } else {
      this.klo = kestoString(keikkaData.pumppu.pumppuAika, keikkaData.pumppu.pumppuKesto);
    }
    this.pumppuPumi = keikkaData.pumppu.isPumppu ? "Pumppu" : "Pumi";
    // get asiakas contact person data
    this.betoniMaksaja = keikkaData.laskutus.isBetoniSuoraLaskutus
      ? keikkaData.asiakas.asiakasNimi
      : keikkaData.pumppuToimittaja.asiakasNimi;
    this.msgHeader = null;
    this.msgSelite = keikkaData.keikkaOtsikko;
    this.msgFooter = null;
    this.asiakasId = keikkaData.asiakas.asiakasId;
    this.asiakasNimi = keikkaData.asiakas.asiakasNimi;
    this.asiakasPuh = keikkaData.asiakas.asiakasContactPersonPhone;
    this.asiakasEmail = keikkaData.asiakas.asiakasContactPersonEmail;
    this.asiakasPersonId = keikkaData.asiakas.asiakasContactPersonId;
    this.asiakasPersonName = "";
    this.tyomaaId = keikkaData.tyomaa.tyomaaId;
    this.tyomaaNimi = keikkaData.tyomaa.tyomaaId > 0 ? keikkaData.tyomaa.tyomaaNimi : "";
    this.tyomaaNimi == this.asiakasNimi ? (this.tyomaaNimi = "") : null;
    this.tyomaaPuh =
      keikkaData.tyomaa.tyomaaId > 0 ? keikkaData.keikkaContactPerson.personPhone : "";
    this.osoite1 = keikkaData.tyomaa.tyomaaOsoite1 + " " + keikkaData.tyomaa.tyomaaOsoite2;
    this.osoite2 = keikkaData.tyomaa.tyomaaOsoite3 + " " + keikkaData.tyomaa.tyomaaOsoite4;
    this.ajoOhje = keikkaData.tyomaa.keikkaAjoOhje || keikkaData.tyomaa.tyomaaAjoOhje;
    this.pumppuToimittaja = keikkaData.pumppuToimittaja.asiakasNimi;
    this.pumppuToimittajaPuh = keikkaData.pumppuToimittaja.asiakasContactPersonPhone;
    this.pumppuToimittajaEmail = keikkaData.pumppuToimittaja.asiakasContactPersonEmail;
    this.pumppuToimittajaPersonId = keikkaData.pumppuToimittaja.asiakasContactPersonId;
    this.puomiInt = keikkaData.pumppu.pumppuPuomi;
    this.puomiString = keikkaData.pumppu.pumppuStringLong;
    this.puomiTxt = "";
    this.linjaInt = keikkaData.pumppu.pumppuLinja;
    this.linjaString = keikkaData.pumppu.linjaStringLong;
    this.linjaHelpTxt = keikkaData.pumppu.linjaHelpTxt;
    this.betoniToimittaja = keikkaData.betoniToimittaja.asiakasNimi;
    this.betoniToimittajaPuh = keikkaData.betoniToimittaja.asiakasContactPersonPhone;
    this.betoniToimittajaEmail = keikkaData.betoniToimittaja.asiakasContactPersonEmail;
    this.betoniToimittajaPersonId = keikkaData.betoniToimittaja.asiakasContactPersonId;
    this.huomioita = keikkaData.keikkaComment
      ? keikkaData.keikkaComment //.replaceAll("\n", "<br>")
      : "";

    this.emailToPersonId = keikkaData.keikkaContactPerson.personId;
    this.keikkaId = keikkaData.keikkaId;
    this.m3Tot = keikkaData.betoniM3Tot;

    this.emailToName = keikkaData.keikkaContactPerson.personFullName;
    this.emailHeader = null;

    this.betoni = [];
    keikkaData.betoni.map((b) => {
      var thisBetoni = new betoniClass();
      thisBetoni.m3 = b.m3;
      thisBetoni.betoniString = b.betoniString;
      thisBetoni.betoniComment = b.betoniComment;
      thisBetoni.laatu = b.laatu.nimike;
      thisBetoni.nopea = b.nopea ? "Nopeast kovettuva" : "Normaalisti kovettuva";
      thisBetoni.raeKoko = b.raeKoko.raeKokoSelite;
      thisBetoni.lujuus = b.lujuus.lujuusSelite.trim();
      thisBetoni.notkeus = b.notkeus.notkeusSelite;
      thisBetoni.rasitus = b.rasitus.rasitusluokat.join(", ");
      thisBetoni.kayttoIka = b.kayttoIka.kayttoIkaSelite;
      this.betoni.push(thisBetoni);
    });
    this.varmenne = keikkaData.varmenne;
  }

  setButtonUrl() {
    this.buttonUrl = "https://betoni.online/tilaus/" + this.keikkaId + "?cc=" + this.confirmCode;
  }

  static getMSISDN(phoneNumber) {
    if (phoneNumber != null) {
      let num = phoneNumber;
      if (num.startsWith("0")) num = "358" + num.substring(1);
      return num;
    } else {
      return "";
    }
  }

  setAsiakasPersonByFetch = async (token) => {
    if (this.asiakasPersonId == 0) return this;
    let p = await person_fetch_by_id(this.asiakasPersonId, token);
    this.asiakasEmail = p.personEmail;
    this.asiakasPuh = p.personPhone;
    this.asiakasPersonName = p.personFirstName + " " + p.personLastName;
    return this;
  };

  static async sendMail(token, data) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/mail/sendMail",
      requestOptions
    );
    await checkResponse(response, "mailClass:sendMail");
    return response;
  }

  async sendNewViestiEmail(token, viesti) {
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";
    this.emailHeader = "Uusi viesti tilaukseen " + this.keikkaId;
    this.msgHeader = "Uusi viesti";
    this.msgSelite = "Asiakas kirjoitti:" + viesti;
    return await mailClass.sendMail(token, this);
  }

  async sendBetoniTilaus(
    token,
    emailHeader = null,
    msgHeader = null,
    msgFooter = null,
    msgSelite = null
  ) {
    this.templateId = "d-74de2940ce204cc194795b8699b790af";
    this.emailHeader = emailHeader || "Betonitilaus";
    this.msgHeader = msgHeader || "Betonitilaus";
    this.msgFooter = msgFooter || "";
    this.msgSelite = msgSelite || "";
    return await mailClass.sendMail(token, this);
  }

  async sendKapasiteettiMuutos(token, autoTxt, poisKloTxt, huomioitaTxt, keikkaId) {
    this.emailToPersonId = 117;
    return await mailClass.sendMail(token, {
      templateId: "d-b9d88fc72cb44406b5a7ab1200698eab",
      emailToEmail: this.emailToEmail,
      //emailHeader:
      pumppuToimittaja: this.pumppuToimittaja,
      keikkaId: keikkaId,
      autoTxt: autoTxt,
      poisKloTxt: poisKloTxt,
      huomioitaTxt: huomioitaTxt,
      confirmCode: this.confirmCode,
    });
  }

  async sendTilausToive(token) {
    // To pumpputoimittaja
    this.emailToPersonId = this.pumppuToimittajaPersonId;
    this.emailToName = this.pumppuToimittaja;
    this.emailToEmail = this.pumppuToimittajaEmail;
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";

    this.emailHeader = "Saapuva pumpputilaus: " + this.m3Tot + "m3 betonia. " + this.puomiString;
    this.msgHeader = "Saapuva pumpputilaus";
    this.msgFooter = "Tämä on asiakkaan toive. Hallitse ja hyväksy tilaus avaamalla betoni.online";
    return await mailClass.sendMail(token, this);
  }

  async sendTarjouspyyntö(token) {
    // To pumpputoimittaja
    this.emailToPersonId = this.pumppuToimittajaPersonId;
    this.emailToName = this.pumppuToimittaja;
    this.emailToEmail = this.pumppuToimittajaEmail;
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";

    this.emailHeader = "Tarjouspyyntö: " + this.m3Tot + "m3 betonia. " + this.puomiString;
    this.msgHeader = "Tarjouspyyntö";
    this.msgFooter =
      "Tämä on asiakkaan lähettämä tarjouspyyntö. Vastaanota tarjouspyyntö betoni.online sivustolta ja lähetä tarjous sähköpostitse asiakkaalle. Merkitse betoni.online sivustolla että tarjous on lähetetty jotta asiakas pystyy tekemään tilauksen.";
    return await mailClass.sendMail(token, this);
  }

  async sendTilausLuonnos(token) {
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";
    this.emailHeader =
      "Betoni ja pumpputilauksen luonnos: " + this.m3Tot + "m3 betonia. " + this.puomiString;
    this.msgHeader = "Betoni ja pumpputilauksen luonnos";
    this.msgFooter =
      "Tämä on esitäytetty luonnos. Voit vielä muokata ja korjata tilausta sekä lähettää sen sivultamme.";
    return await mailClass.sendMail(token, this);
  }

  async sendTilaustiedot(token) {
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";

    this.emailHeader =
      this.emailHeader ||
      "Betonin ja pumpun tilaustiedot. " + this.m3Tot + "m3 betonia. " + this.puomiString;
    this.msgHeader = this.msgHeader || "Betonin ja pumpun tilaustiedot";
    this.msgFooter =
      this.msgFooter ||
      "Tarkastathan tilauksesi tiedot ja otat yhteyttä mikäli huomaat virheitä tai sinulle herää kysyttävää. \n\n" +
      this.pumppuToimittaja +
      " " +
      this.pumppuToimittajaPuh;

    if (this.asiakasPuh == null) await this.setAsiakasPersonByFetch(token);

    // send mail
    return await mailClass.sendMail(token, this);
  }

  async sendTilausvahvistus(token) {
    this.templateId = "d-d1e5ed7affbe4cc5843fe2be6326c6f6";
    this.emailHeader =
      this.emailHeader ||
      "Betonin ja pumpun tilausvahvistus " + this.m3Tot + "m3 betonia. " + this.puomiString;
    this.msgHeader = this.msgHeader || "Betonin ja pumpun tilausvahvistus";
    this.msgFooter =
      this.msgFooter ||
      "Tilaus on vahvistettu. Tarkastathan tilauksesi tiedot ja otat yhteyttä mikäli huomaat virheitä tai sinulle herää kysyttävää. \n\n" +
      this.pumppuToimittaja +
      " " +
      this.pumppuToimittajaPuh;

    if (this.asiakasPuh == null) await this.setAsiakasPersonByFetch(token);

    // send mail
    return await mailClass.sendMail(token, this);
  }
}

class betoniClass {
  m3;
  betoniString;
  betoniComment;
}
